import { Box, TableContainer } from "@material-ui/core";
import { FC, useEffect, useRef } from "react";
import { useStyles } from "../styles";
import FleetStatusTable from "./FleetStatusTable";


interface PropsType {}

const FleetStatussContainers: FC<PropsType> = () => {
  const classes = useStyles();

  const table1Ref = useRef<any>(null);
  const table2Ref = useRef<any>(null);

  useEffect(() => {
    const t1 = table1Ref.current;
    const t2 = table2Ref.current;

    if (!t1 || !t2) return;

    const syncScroll = (source: any, target: any) => {
      target.scrollTop = source.scrollTop;
    };

    const handleScroll1 = () => syncScroll(t1, t2);
    const handleScroll2 = () => syncScroll(t2, t1);

    t1.addEventListener("scroll", handleScroll1);
    t2.addEventListener("scroll", handleScroll2);

    return () => {
      t1.removeEventListener("scroll", handleScroll1);
      t2.removeEventListener("scroll", handleScroll2);
    };
  }, []);


  return (
    <Box>
      <Box style={{ display: "flex" }}>
        <TableContainer
          className={classes.tableContainer}
          ref={table1Ref}
        >
          <FleetStatusTable tableNumber={1} />
        </TableContainer>
        <TableContainer
          className={classes.tableContainer2}
          ref={table2Ref}
        >
          <FleetStatusTable tableNumber={2} />
        </TableContainer>
      </Box>
    </Box>
  );
};

export default FleetStatussContainers;
